<template>
    <design-2021-apprentice-line-chart-component
        :series="series"
        :options="chartOptions"
    ></design-2021-apprentice-line-chart-component>
</template>

<script>
export default {
    name: "design-2021-statistics-index-timeline-component",
    props: [
        'profilesNumbersIn',
        'profilesLabelsIn'
    ],
    data() {
        return {
            series : [{
                name : this.$t('statistics.cards'),
                data: this.profilesNumbersIn
            }],
            chartOptions: {
                chart: {
                    type: 'line',
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#17a2b8'],
                xaxis: {
                    categories: this.profilesLabelsIn,
                },
                markers: {
                    size: 4,
                },
                stroke: {
                    curve: 'smooth',
                },
                grid: {
                    show: true,
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    }
                }
            }
        }
    },
    computed: {
        customStyles() {
            return {
                height: `${this.height}px`,
                width: '100%',
                position: 'relative',
            }
        },
    },
}
</script>

<style scoped>

</style>
